var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"phoca-flag",class:_vm.flag})
}
var staticRenderFns = []

export { render, staticRenderFns }